import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import Menu from '../components/Menu';
import api from '../services/api';
import ControleQualidadeDetalhe from '../components/Tabelas/ControleQualidadeDetalhe';

export default function ControleQualidade() {
    const location = useLocation();

    const [dataInicial, setDataInicial] = useState(() => {
        if (location.state && location.state.date) {
            return new Date(location.state.date);
        }
        const data = new Date();
        data.setDate(data.getDate() - 30);
        return data;
    });
    const [dataFinal, setDataFinal] = useState(() => {
        if (location.state && location.state.date) {
            return new Date(location.state.date);
        }
        return new Date();
    });
    const [loading, setLoading] = useState(false);
    const [defeitosList, setDefeitosList] = useState([]);
    const [defeitosMap, setDefeitosMap] = useState({});
    const [selectedDefeito, setSelectedDefeito] = useState(null);
    const [detalheData, setDetalheData] = useState(null);

    const toast = useRef(null);

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        api.get(`defeitos/historico/graficos/${today}/${today}/null/null/null/true`)
            .then(response => {
                const map = {};
                if (response.data && response.data.defeitos) {
                    response.data.defeitos.forEach(d => {
                        map[d.nome] = d.id;
                    });
                }
                setDefeitosMap(map);
            })
            .catch(err => console.error("Erro ao carregar mapa de defeitos", err));
    }, []);

    const buscarDados = () => {
        setLoading(true);
        setSelectedDefeito(null);
        
        const di = dataInicial.toISOString().split('T')[0];
        const df = dataFinal.toISOString().split('T')[0];

        api.get(`defeitos/historico/graficos/${di}/${df}`)
            .then(response => {
                const porDefeito = response.data.por_defeito || [];
                const totalMetrosGeral = porDefeito.reduce((acc, curr) => acc + parseFloat(curr.total_metros), 0);
                
                const tableData = porDefeito.map(d => {
                    const metros = parseFloat(d.total_metros);
                    const percentual = totalMetrosGeral > 0 ? (metros / totalMetrosGeral) * 100 : 0;
                    return {
                        nome: d.nome,
                        metros: metros,
                        percentual: percentual
                    };
                });

                //A-Z
                tableData.sort((a, b) => a.nome.localeCompare(b.nome));
                setDefeitosList(tableData);
            })
            .catch(error => {
                toast.current?.show({
                    summary: 'Erro',
                    severity: 'error',
                    detail: 'Não foi possível carregar os dados.'
                });
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        buscarDados();
    }, []);

    const handleRowClick = (e) => {
        const rowData = e.data;
        const defeitoId = defeitosMap[rowData.nome];
        
        if (!defeitoId) {
            toast.current?.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'ID do defeito não encontrado.'
            });
            return;
        }

        setLoading(true);
        const di = dataInicial.toISOString().split('T')[0];
        const df = dataFinal.toISOString().split('T')[0];

        api.get(`defeitos/historico/graficos/${di}/${df}/null/null/${defeitoId}`)
            .then(response => {
                setDetalheData({
                    nomeDefeito: rowData.nome,
                    totalMetros: rowData.metros,
                    ...response.data
                });
                setSelectedDefeito(rowData);
            })
            .catch(error => {
                toast.current?.show({
                    summary: 'Erro',
                    severity: 'error',
                    detail: 'Não foi possível carregar os detalhes do defeito.'
                });
            })
            .finally(() => setLoading(false));
    };

    const percentualBodyTemplate = (rowData) => {
        return `${rowData.percentual.toFixed(2)}%`;
    };

    const metrosBodyTemplate = (rowData) => {
        return rowData.metros.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <div className="p-m-3">
                {!selectedDefeito ? (
                    <Card title="Controle de Qualidade">
                        <div className="p-grid p-align-end p-mb-3">
                            <div className="p-col-12 p-md-3">
                                <label>Data Inicial</label>
                                <Calendar 
                                    value={dataInicial} 
                                    onChange={(e) => setDataInicial(e.value)} 
                                    dateFormat="dd/mm/yy" 
                                    mask="99/99/9999"
                                    style={{ width: '100%' }}
                                    inputStyle={{ width: '100%' }}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Data Final</label>
                                <Calendar 
                                    value={dataFinal} 
                                    onChange={(e) => setDataFinal(e.value)} 
                                    dateFormat="dd/mm/yy" 
                                    mask="99/99/9999"
                                    style={{ width: '100%' }}
                                    inputStyle={{ width: '100%' }}
                                />
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Buscar" icon="pi pi-search" onClick={buscarDados} loading={loading} className="p-w-100" />
                            </div>
                        </div>

                        {loading ? (
                            <div className="p-d-flex p-jc-center p-mt-5">
                                <ProgressSpinner />
                            </div>
                        ) : (
                            defeitosList.length > 0 && (
                                <div>
                                    <p className="p-text-italic">Clique em um defeito para visualizar os detalhes (classificado de A a Z)</p>
                                    <DataTable 
                                        value={defeitosList} 
                                        className="p-datatable-sm p-datatable-striped" 
                                        onRowClick={handleRowClick}
                                        rowHover
                                        selectionMode="single"
                                    >
                                        <Column field="nome" header="LISTA DE DEFEITOS" sortable></Column>
                                        <Column field="metros" header="METROS" body={metrosBodyTemplate} sortable></Column>
                                        <Column field="percentual" header="PERCENTUAL" body={percentualBodyTemplate} sortable></Column>
                                    </DataTable>
                                </div>
                            )
                        )}
                    </Card>
                ) : (
                    <ControleQualidadeDetalhe 
                        data={detalheData} 
                        onBack={() => setSelectedDefeito(null)} 
                    />
                )}
            </div>
        </div>
    );
}
